module.exports = __webpack_public_path__ + "img/btn-pre-reservation-no.efb9a0a8.png";